import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Carlos M.',
  location: 'Miami, FL',
  quote: 'Llevaba 2 años comprando leads de Zillow y gastando $3,000 al mes sin resultados consistentes. En 60 días con el Sistema A.C.E.™ cerré 4 transacciones de compradores pre-aprobados. Nunca había tenido un pipeline tan limpio.'
}, {
  name: 'Sandra R.',
  location: 'Houston, TX',
  quote: 'Mi base de datos tenía 400 contactos dormidos. Pensé que ya no servían. La secuencia de reactivación generó 3 referidos en el primer mes. Dos de ellos ya están en contrato.'
}, {
  name: 'Miguel A.',
  location: 'Orlando, FL',
  quote: 'Antes dependía 100% de mi esfera personal. Ya la había agotado. Ahora tengo un sistema que me trae compradores con carta de pre-aprobación listos para ver propiedades esta semana.'
}];
export function TestimonialsSection() {
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-dark-300 border-y border-dark-100" data-id="element-261">
      <div className="max-w-7xl mx-auto" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-24" data-id="element-263">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-264">
            Lo Que Dicen <span className="text-gold" data-id="element-265">Nuestros Agentes</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10" data-id="element-266">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative bg-dark-200/30 hover:bg-dark-200/60 transition-colors p-8 md:p-10 rounded-xl flex flex-col" data-id="element-267">
              <span className="absolute -top-6 -left-2 text-8xl text-gold/10 font-serif leading-none select-none" data-id="element-268">
                "
              </span>

              <div className="flex gap-1 mb-6 relative z-10" data-id="element-269">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-xl" data-id="element-270">
                    ★
                  </span>)}
              </div>

              <p className="text-gray-300 text-base md:text-lg leading-relaxed flex-1 mb-8 italic relative z-10" data-id="element-271">
                "{t.quote}"
              </p>

              <div className="relative z-10" data-id="element-272">
                <span className="text-white font-bold text-lg block uppercase tracking-wide" data-id="element-273">
                  {t.name}
                </span>
                <span className="text-gold/60 text-sm font-medium uppercase tracking-widest" data-id="element-274">
                  {t.location}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}